// extracted by mini-css-extract-plugin
export default {"selector":"zqBXqYUWHXeVDQuwxM4t","icon":"XVL6E8eONsLIsojv8mnX"};